export const bulkSavePropertiesModalId = 'bulk-save-properties';
